import request from '@/router/axios'
import env from '@/config/env'
import globalVariable from '@/config/globalVariable'

const { TIME } = globalVariable

/**
 * 查询城际公司名称
 */
export const getAllLowMerchant = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/getAllLowMerchant',
    method: 'GET',
    timeout: TIME
  })
}

/**
 * 查询城际车牌号
 * @param
 */
export const getCar = () => {
  return request({
    url: env.ferryUrl + '/c-order/queryMerchantDriverAndCarInfo',
    method: 'POST',
    timeout: TIME
  })
}

/**
 * 获取线路名称
 * @param params
 */
export const queryAllLowLine = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/queryAllLowLine',
    method: 'GET',
    timeout: TIME
  })
}

/**
 * 获取票款结算规则分页
 * @param params
 */
export const clarifyFerryPage = (params) => {
  return request({
    url: env.ferryUrl + '/ferry-liquidation/page',
    method: 'POST',
    timeout: TIME,
    data: params
  })
}

/**
 * 获取接送服务区域
 * @param
 */
export const getServiceAreaItem = (areaManageId) => {
  return request({
    url: env.ferryUrl + `/priceModuleManage/serviceAreaList/${areaManageId}`,
    method: 'POST',
    timeout: TIME
  })
}

/**
 * 根据时间批量清分摆渡单
 * @param
 */
export const clarifyFerrySync = (params) => {
  return request({
    url: env.ferryUrl + '/ferry-liquidation/save-by-time',
    method: 'POST',
    timeout: TIME,
    data: params
  })
}
